import { render, staticRenderFns } from "./formContactDialog.vue?vue&type=template&id=6d700fb6&scoped=true"
import script from "./formContactDialog.vue?vue&type=script&lang=js"
export * from "./formContactDialog.vue?vue&type=script&lang=js"
import style0 from "./formContactDialog.vue?vue&type=style&index=0&id=6d700fb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d700fb6",
  null
  
)

export default component.exports